import { BottomActions } from "app/components/BottomActions";
import DataTable from "app/components/DataTable";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { ScrollableView } from "app/components/ScrollableView";
import { selectFeaturePermissions } from "store/global/authPermission/selector";
import { PermissionFeature } from "store/global/authPermission/types";
import { getFormattedDateTime } from "utils/helpers";
import useWindowDimensions from "utils/hooks/useWindowDimensions";
import { selectOpenList, selectOpenQuery } from "../../redux/selector";
import { actions } from "../../redux/slice";
import { useStyles } from "./styles";
const OpenList = () => {
  function editOnClickOpen(val) {
    navigate(`/questionnaires/open/${val.id}?mode=edit`);
  }

  function onClickOpen(val) {
    navigate(`/questionnaires/open/${val.id}?mode=view`);
  }

  const { q, orderField, orderDirection } = useSelector(selectOpenQuery);
  const { items, meta, loading } = useSelector(selectOpenList);

  useEffect(() => {
    dispatch(actions.getOpenList());
  }, [q, orderField, orderDirection]);

  const { t } = useTranslation();

  const columns = [
    {
      id: "createdAt",
      label: t("QUESTIONNAIRES.DATE_CREATED"),
      sortValue: "selector.createdAt",
      align: "left",
      format: (val) => {
        return getFormattedDateTime(val.createdAt);
      },
    },
    {
      id: "updatedAt",
      label: t("QUESTIONNAIRES.DATE_EDITED"),
      sortValue: "selector.updatedAt",
      align: "left",
      format: (val) => {
        return getFormattedDateTime(val.updatedAt);
      },
    },
    {
      id: "name",
      label: t("QUESTIONNAIRES.QUESTIONNAIRE_NAME"),
      sortValue: "selector.name",
      align: "left",
    },
    {
      id: "totalQuestions",
      label: t("QUESTIONNAIRES.NUMBER_OF_QUESTIONS"),
      sortValue: "selector.totalQuestions",
      align: "left",
    },
    {
      id: "organizationName",
      label: t("QUESTIONNAIRES.ORGANIZATION_NAME"),
      sortValue: "organization.name",
      align: "left",
    },
  ];
  const dispatch = useDispatch();
  const styles = useStyles();
  const navigate = useNavigate();
  const setPageQuery = (name: string, value: any) => {
    dispatch(actions.setQuery({ name, value }));
  };

  const handleAddOpen = () => {
    navigate("/questionnaires/open/add?mode=add");
  };
  const featurePermissions = useSelector(selectFeaturePermissions);
  const { hasFullAccess, hasReadAccess, hasNoAccess } =
    featurePermissions[PermissionFeature.QUESTIONNAIRES];
  const hasMoreItems = meta.currentPage < meta.totalPages;
  const getNextPage = () => {
    if (!loading) {
      dispatch(actions.getOpenNextPage(meta.currentPage + 1));
    }
  };
  const { height } = useWindowDimensions();
  return (
    <>
      <ScrollableView
        loadMore={getNextPage}
        hasMoreItems={hasMoreItems}
        height={height - 280}
      >
        <DataTable
          loading={loading}
          orderDirection={orderDirection}
          orderField={orderField}
          setQuery={setPageQuery}
          rows={items}
          Actions={hasFullAccess ? "Edit" : ""}
          columns={columns}
          editAction={editOnClickOpen}
          onRowDoubleClick={onClickOpen}
        />
      </ScrollableView>
      <BottomActions
        disabled={!hasFullAccess}
        chipBoxes={[
          {
            label: t("PLACEHOLDERS.TOTAL_ITEMS"),
            count: meta?.totalItems,
          },
        ]}
        onClickFab={handleAddOpen}
      />
    </>
  );
};

export default OpenList;
